import includes from 'lodash/includes';
import isEqual from 'lodash/isEqual';
import React, { Component } from 'react';
import { Query } from 'react-apollo';
import { NavLink, Redirect } from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';
import { ADMIN, GAME, LOGOUT, apiUrl } from '../../routes';
import Loader from '../Loader';
import WelcomeFooter from '../WelcomeFooter';
import WelcomeHeader from '../WelcomeHeader';
import blurredBackground from './assets/img/background-blurred.jpg';
import erisLogo from './assets/img/eris.svg';
import gql from 'graphql-tag';
import './styles.scss';

const USER_QUERY = gql`
  query appQuery {
    user {
      id
      username
      firstName
      lastName
      roles
      games: playerGames {
        id
        team
        session {
          id
          name
        }
      }
    }
  }
`;
class Home extends Component {
	render() {
		return (
			<Query query={USER_QUERY}>
				{({ loading, data, error }) => {
					if (loading) {
						return <Loader />;
					}
					const { user } = data;
					const { username, firstName, lastName } = user;
					if (isEqual(user.roles, ['player']) && user.games.length === 1)
						return (
							<Redirect to={formatRoute(GAME, { gameID: user.games[0].id })} />
						);
					return (
						<div
							className="LoginRoute"
							style={{ backgroundImage: `url(${blurredBackground})` }}>
							<WelcomeHeader />
							<div className="LoginRoute-content">
								<div className="LoginBox">
									<div className="LoginBox-header">
										<img className="LoginBox-logo" src={erisLogo} alt="Eris" />
										<h2 className="LoginBox-title">Business simulation</h2>
									</div>
									<div className={'LoginBox-body'}>
										<span className="LoginBox-welcome">
											Welcome,{' '}
											{lastName && firstName
												? `${firstName} ${lastName}`
												: username}
										</span>
										{user.games.length > 0 && (
											<div className="LoginBox-games">
												{user.games.map(game => (
													<NavLink
														key={game.id}
														to={formatRoute(GAME, { gameID: game.id })}>
														<strong>session:</strong>
														<span>{game.session.name}</span>
														<strong>team:</strong>
														<span>{game.team}</span>
													</NavLink>
												))}
											</div>
										)}
									</div>
									<div className="LoginBox-footer">
										{(includes(user.roles, 'admin') ||
											includes(user.roles, 'instructor')) && (
											<NavLink
												to={ADMIN}
												className="LoginBox-button"
												style={{
													margin: '0 0 40px 0',
													display: 'inline-block'
												}}>
													Enter Admin Dashboard
											</NavLink>
										)}
										<a
                      href={apiUrl(LOGOUT, { redirect: window.location.href })}
                      className="LoginBox-link LoginBox-link--dark"
                    >
											Logout
										</a>
									</div>
								</div>
							</div>
							<WelcomeFooter />
						</div>
					);
				}}
			</Query>
		);
	}
}

export default Home;
